import React from 'react';
import Header from '../components/Header';

const Home = () => (
  <div className="page">
    <Header size="large" />
  </div>
);

export default Home;
